import ReactECharts from "echarts-for-react";

export default function LineChartFleet({
  lineChartSpeedMonthData,
  lineChartMileageMonthData,
  lineMonths,
}) {
  function formatMonth(yyyymm) {
    const year = Math.floor(yyyymm / 100);
    const month = (yyyymm % 100) - 1;
    return new Date(year, month).toLocaleString("en-US", { month: "short" });
  }

  function formatDay(index) {
    return `Day${index + 1}`;
  }

  function calculateAverage(data) {
    return data.map((item) => {
      const distance = item.Total_distance_km?.value || 0;
      const vehicles = item.Vehicle_id?.value || 0;
      return vehicles ? Number((distance / vehicles).toFixed(2)) : 0;
    });
  }

  function transform(lineChartSpeedMonthData, lineChartMileageMonthData) {
    if (!lineChartSpeedMonthData || !lineChartMileageMonthData) {
      return { xAxis: [], Engine_Runtime_Hrs: [], Total_distance_KM: [] };
    }

    return {
      xAxis: lineChartSpeedMonthData.map((item, index) =>
        lineMonths === "month" ? formatMonth(item.key?.Month) : formatDay(index)
      ),
      Engine_Runtime_Hrs: calculateAverage(lineChartSpeedMonthData),
      Total_distance_KM: calculateAverage(lineChartMileageMonthData),
    };
  }

  if (
    !lineChartSpeedMonthData ||
    !lineChartMileageMonthData ||
    !Array.isArray(lineChartSpeedMonthData) ||
    !Array.isArray(lineChartMileageMonthData)
  ) {
    return <div>Error: Data is missing or invalid.</div>;
  }

  const result = transform(lineChartSpeedMonthData, lineChartMileageMonthData);

  if (
    !result.xAxis.length ||
    !result.Engine_Runtime_Hrs.length ||
    !result.Total_distance_KM.length
  ) {
    return (
      <div className="text-center text-red-600 text-sm p-2 m-4">
        No data available for chart.
      </div>
    );
  }

  const xAxisData = result.xAxis;

  const series = [
    {
      name: "Engine_Runtime_Hrs",
      type: "line",
      smooth: true,
      data: result.Engine_Runtime_Hrs,
      yAxisIndex: 0,
      tooltip: {
        valueFormatter: (value) => value + " Hrs",
      },
    },
    {
      name: "Total_distance_KM",
      type: "line",
      smooth: true,
      data: result.Total_distance_KM,
      yAxisIndex: 1,
      tooltip: {
        valueFormatter: (value) => value + " KM",
      },
    },
  ];

  const options = {
    grid: {
      left: "20%",
      right: "20%",
      top: "25%",
      bottom: "10%",
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
      },
    },
    legend: {
      data: ["Engine_Runtime_Hrs", "Total_distance_KM"],
    },
    xAxis: {
      type: "category",
      data: xAxisData,
      splitLine: {
        show: false,
      },
    },
    yAxis: [
      {
        type: "value",
        name: "Engine Runtime (Hrs)",
        position: "left",
        alignTicks: true,
        axisLine: {
          show: true,
          lineStyle: {
            color: "#5470C6",
          },
        },
        axisLabel: {
          formatter: "{value} Hrs",
        },
        splitLine: {
          show: false,
        },
      },
      {
        type: "value",
        name: "Total Distance (KM)",
        position: "right",
        alignTicks: true,
        axisLine: {
          show: true,
          lineStyle: {
            color: "#91CC75",
          },
        },
        axisLabel: {
          formatter: "{value} KM",
        },
        splitLine: {
          show: false,
        },
      },
    ],
    series,
  };

  return (
    <div className="h-[300px] w-full">
      <ReactECharts option={options} style={{ height: "100%" }} />
    </div>
  );
}
